import { Navigate } from "react-router-dom";
const PrivateRoute = ({ children }) => { //  isLoggedIn,
    const isLoggedIn = localStorage.getItem("user_text_obj_data1") ? true : false; 
    if (isLoggedIn == false) {
        return <Navigate to="/login" replace />;
    }
    return children;
};
export default PrivateRoute; 